export interface SpacerProps {
  amount?: number;
  inline?: boolean;
}

export const Spacer = ({ amount = 1, inline }: SpacerProps) => {
  return (
    <div
      className={inline ? 'inline' : ''}
      style={{ margin: 8 * amount }}
    />
  );
};
